import React from 'react';
// data
import Data from '../../../../model/Data';
import { links } from '../../data.json';
// styles
import './Footer.css'

interface Props {
  className?: string;
}

class Footer extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <div className="about-footer">
        <div className="container">
          <div className="about-footer__message">
            хотите узнать больше?
          </div>
          <div className="about-footer__blogs">
            читайте блоги Учи.ру на
            <a href={links.vc}> VC </a>
            и
            <a href={links.habr}> Хабр</a>
          </div>
          <div className="about-footer__social">
            подписывайтесь на нас в
            <a href={links.telegram}> TG </a>
            и
            <a href={links.vk}> VK </a>
          </div>
          <div className="about-footer__signs"></div>
        </div>
      </div>
    );
  }
}

export default Footer;
